import { render } from "./AddFarmerModal2.vue?vue&type=template&id=23a85e74&scoped=true"
import script from "./AddFarmerModal2.vue?vue&type=script&lang=js"
export * from "./AddFarmerModal2.vue?vue&type=script&lang=js"

import "./AddFarmerModal2.vue?vue&type=style&index=0&id=23a85e74&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23a85e74"]])

export default __exports__